@if (shouldDisplay()) {
<mat-nav-list>
	<a mat-list-item routerLink="/sommerfest-registration">
		<img matListItemAvatar src="assets/img/ystm-sommerfest-2026-plakat-v2.png" alt="YSTM Sommerfest 2026">
		<span matListItemTitle>65 Jahre YSTM</span>
		<span matListItemLine>Sommerfest am 20.06.2026</span>
		<span matListItemLine><strong>Jetzt anmelden</strong> </span>
		<!-- <button mat-icon-button matListItemMeta>
			<mat-icon>app_registration</mat-icon>
		</button> -->
	</a>
</mat-nav-list>
} 